import { Field, Float, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { Product } from '../Product'
import type { IAction } from '../../action/IAction'

@InputType()
export class AdjustProductQuantityServiceArgs extends ActionArgs {
  @Field(() => String)
  productId: string

  @Field(() => Float)
  quantity: number

  @Field(() => String)
  remarks: string

  @Field(() => [String])
  tags: string[]
}

export interface IAdjustProductQuantityService extends IAction<Product, AdjustProductQuantityServiceArgs> {}
